angular.module('aprima-core-ui').directive('apBirthdate', ['DateUtilities', function (DateUtilities) {
    'use strict';


    return{
        restrict: 'E',
        scope: {
            birthdate: '@',
            deathdate: '@',
            display: '@'
        },
        compile: function () {
            var _link = function (scope, elem) {

                elem.html(DateUtilities.displayAge(DateUtilities.getPersonAge(scope.birthdate, scope.deathdate), {display: scope.display}));

                var watchRemover = scope.$watchCollection('[birthdate, deathdate, display]', function (newval, oldval) {
                    var person;
                    if (newval !== oldval) {
                        person = DateUtilities.getPersonAge(newval[0], newval[1]);
                        elem.html(DateUtilities.displayAge(person, {display: newval[2]}));
                    }
                });

                scope.$on('$destroy', function(){
                    watchRemover();
                });
            };

            return _link;
        }
    };
}]);
